import { render, staticRenderFns } from "./ModalInserirNoticia.vue?vue&type=template&id=cbaf941e&scoped=true"
import script from "./ModalInserirNoticia.vue?vue&type=script&lang=js"
export * from "./ModalInserirNoticia.vue?vue&type=script&lang=js"
import style0 from "./ModalInserirNoticia.vue?vue&type=style&index=0&id=cbaf941e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbaf941e",
  null
  
)

export default component.exports